import { useReduxState } from 'hooks';

import type { Event } from 'shared-types';

interface Props {
  data: Event['data'];
  visible?: boolean;
}

const EventLogEntryData = ({ data, visible }: Props) => {
  const { theme } = useReduxState();

  if (!visible) return null;

  return (
    <div className="data">
      <pre className="content">
        <code>{JSON.stringify(data, null, 2)}</code>
      </pre>

      <style jsx>{`
        .data {
          background-color: ${theme.lightGrey};
          border-radius: ${theme.cardBorderRadius};
          font-size: 1.4rem;
          margin-top: 10px;
        }
        .content {
          font-size: 1.4rem;
          overflow-y: auto;
          padding: 10px 15px;
          white-space: pre-wrap;
          width: 100%;
        }
      `}</style>
    </div>
  );
};

export default EventLogEntryData;
